import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "w-100 h-100" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Current Premium:", -1 /* HOISTED */)),
                      _createTextVNode(" " + _toDisplayString($setup.formatCurrency($props.premiumSummary.currentPremium)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("strong", null, "New Premium:", -1 /* HOISTED */)),
                      _createTextVNode(" " + _toDisplayString($setup.formatCurrency($props.premiumSummary.newPremium)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    class: _normalizeClass($setup.showDifference($props.premiumSummary.currentPremium, $props.premiumSummary.newPremium))
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Difference:", -1 /* HOISTED */)),
                      _createTextVNode(" " + _toDisplayString($setup.getDifference($props.premiumSummary.currentPremium, $props.premiumSummary.newPremium)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.premiumSummary.lines, (line, index) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(line.insuranceLineCode) + " - Line Premiums", 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Current:", -1 /* HOISTED */)),
                            _createTextVNode(" " + _toDisplayString($setup.formatCurrency(line.currentPremium)), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _cache[4] || (_cache[4] = _createElementVNode("strong", null, "New:", -1 /* HOISTED */)),
                            _createTextVNode(" " + _toDisplayString($setup.formatCurrency(line.newPremium)), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, {
                          class: _normalizeClass($setup.showDifference(line.currentPremium, line.newPremium))
                        }, {
                          default: _withCtx(() => [
                            _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Difference:", -1 /* HOISTED */)),
                            _createTextVNode(" " + _toDisplayString($setup.getDifference(line.currentPremium, line.newPremium)), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_divider, { class: "my-2" }),
                    _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Line Coverages", -1 /* HOISTED */)),
                    (line.coverages.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("strong", null, "Code", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { class: "text-center" }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("strong", null, "Current", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { class: "text-center" }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("strong", null, "New", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { class: "text-center" }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("strong", null, "Difference", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.coverages, (coverage) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: coverage.coverageCode
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(coverage.coverageCode), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_v_col, { class: "text-right" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(coverage.currentPremium)), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_v_col, { class: "text-right" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(coverage.newPremium)), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_v_col, {
                                    class: _normalizeClass(['text-right', $setup.showDifference(coverage.currentPremium, coverage.newPremium)])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.getDifference(coverage.currentPremium, coverage.newPremium)), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_v_divider, { class: "my-2" }),
                    _cache[23] || (_cache[23] = _createElementVNode("h4", null, "Units", -1 /* HOISTED */)),
                    (line.units.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createElementVNode("strong", null, "Unit:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createElementVNode("strong", null, "State:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("strong", null, "Location:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("strong", null, "SubLocation:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { class: "text-center" }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createElementVNode("strong", null, "Current:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { class: "text-center" }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("strong", null, "New:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { class: "text-center" }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("strong", null, "Difference:", -1 /* HOISTED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_expansion_panels, { multiple: "" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.units, (unit, uIndex) => {
                          return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: uIndex }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(unit.unit), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(unit.state), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(unit.location), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(unit.sublocation), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, { class: "text-right" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.formatCurrency(unit.currentPremium)), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, { class: "text-right" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.formatCurrency(unit.newPremium)), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, {
                                        class: _normalizeClass(['text-right', $setup.showDifference(unit.currentPremium, unit.newPremium)])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.getDifference(unit.currentPremium, unit.newPremium)), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Coverages", -1 /* HOISTED */)),
                                  (unit.coverages.length > 0)
                                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                              _createElementVNode("strong", null, "Code", -1 /* HOISTED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          }),
                                          _createVNode(_component_v_col, { class: "text-center" }, {
                                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                              _createElementVNode("strong", null, "Current", -1 /* HOISTED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          }),
                                          _createVNode(_component_v_col, { class: "text-center" }, {
                                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                              _createElementVNode("strong", null, "New", -1 /* HOISTED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          }),
                                          _createVNode(_component_v_col, { class: "text-center" }, {
                                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                              _createElementVNode("strong", null, "Difference", -1 /* HOISTED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unit.coverages, (coverage) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: coverage.coverageCode
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(coverage.coverageCode), 1 /* TEXT */)
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */),
                                                _createVNode(_component_v_col, { class: "text-right" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.formatCurrency(coverage.currentPremium)), 1 /* TEXT */)
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */),
                                                _createVNode(_component_v_col, { class: "text-right" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.formatCurrency(coverage.newPremium)), 1 /* TEXT */)
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */),
                                                _createVNode(_component_v_col, {
                                                  class: _normalizeClass(['text-right', $setup.showDifference(coverage.currentPremium, coverage.newPremium)])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.getDifference(coverage.currentPremium, coverage.newPremium)), 1 /* TEXT */)
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}